<template>
  <nav class="navigation fixed inset-x-0 top-0 z-[1000]">
    <div class="nav-content max-w-[1200px] mx-auto flex justify-between items-center px-4 md:px-5">
      <router-link to="/" class="nav-logo flex items-center gap-2 md:gap-3" :aria-label="$t('nav.homeLink')">
        <img src="https://i.ibb.co/p6L4bHsL/logo-Personal-Coding.png" alt="Logo" class="logo h-7 md:h-8 w-auto">
        <div class="logo-title">
          <div class="logo-title-main font-bold text-lg md:text-xl">{{ $t('nav.title') }}</div>
          <div class="logo-title-sub text-xs md:text-sm opacity-80">{{ $t('nav.subtitle') }}</div>
        </div>
      </router-link>
      <div class="nav-links flex items-center gap-4">
        <LanguageSelector />
        <ThemeSwitch class="hidden" />
      </div>
    </div>
  </nav>
</template>

<script>
import ThemeSwitch from '../ThemeSwitch.vue'
import LanguageSelector from '../LanguageSelector.vue'

export default {
  name: 'NavigationBar',
  components: {
    ThemeSwitch,
    LanguageSelector
  },
  data() {
    return {}
  },
  mounted() {},
  unmounted() {},
  methods: {}
}
</script>

<style scoped>
.navigation {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 14px 0;
  transition: all 0.25s ease;
  background: var(--glass-bg) !important;
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
}

/* Ensure fixed/sticky behavior in Light Theme explicitly */
:global(.light-theme) .navigation {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* Removed scrolled state - no dynamic scroll behavior */

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  pointer-events: auto; /* re-enable interactions inside */
}

.nav-logo {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.nav-logo:hover {
  opacity: 0.9;
}

.logo {
  height: 40px;
  width: auto;
}

.logo-title {
  color: var(--text-primary);
  letter-spacing: 0.2px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.35);
  white-space: nowrap;
}

.logo-title-main {
  font-weight: 800;
}

.logo-title-sub {
  font-weight: 600;
  color: var(--text-secondary);
}

@media (max-width: 430px) {
  .navigation { padding: 8px 0; }
  .nav-content { padding: 0 14px; }
  .logo { height: 28px; }
  .logo-title { font-size: 0.9rem; }
  .nav-links .cta-button {
    padding: 8px 14px;
    font-size: 0.85rem;
    border-radius: 20px;
  }
}

.nav-links {
  display: flex;
  gap: 30px;
  align-items: center;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.25s ease;
}

.nav-links a:hover {
  color: #00ffb3;
  transform: translateY(-1px);
}

.nav-links .social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 9999px;
  background: var(--gradient-purple-blue);
  box-shadow: 0 6px 18px rgba(139, 92, 246, 0.35);
  border: 1px solid rgba(255,255,255,0.12);
}

.nav-links .social-link i {
  color: white;
}

.nav-links .cta-button {
  background: rgba(139, 92, 246, 0.15);
  backdrop-filter: blur(20px) saturate(180%);
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  padding: 10px 20px;
  border-radius: 25px;
  color: white;
  transition: all 0.25s ease;
  box-shadow: 0 8px 24px rgba(217, 70, 239, 0.28);
  border: 1px solid rgba(255,255,255,0.15);
}

.nav-links .cta-button:hover {
  transform: translateY(-2px);
  background: rgba(139, 92, 246, 0.25);
  backdrop-filter: blur(25px) saturate(200%);
  -webkit-backdrop-filter: blur(25px) saturate(200%);
  border-color: rgba(255, 255, 255, 0.25);
  box-shadow: 0 12px 28px rgba(217, 70, 239, 0.35);
}


@media (max-width: 768px) {
  .nav-links {
    gap: 12px;
  }
  
  .logo-text-main {
    font-size: 0.9rem;
  }
  
  .logo-text-subtitle {
    font-size: 0.6rem;
  }
  
  .nav-logo {
    gap: 8px;
  }
  
  .logo {
    height: 35px;
  }
}

@media (max-width: 480px) {
  .logo-text-main {
    font-size: 0.8rem;
  }
  
  .logo-text-subtitle {
    font-size: 0.5rem;
  }
  
  .nav-logo {
    gap: 6px;
  }
  
  .logo {
    height: 30px;
  }
}
</style> 